import { EditorClient } from '@newtral/editor-svc-client/esm';

const BackendApi = new EditorClient(window._env_.REACT_APP_BACKEND);

export default BackendApi;